import {
  BillList,
  PendingApprovalBillList,
  CreateBill,
  CreateAccount,
  Home,
  AccountInfo,
  AccountList,
  Profile,
  BillInfo,
  InvoiceHistory,
  InvoiceConfig,
  QrPaymentSlipPage,
} from 'Pages';
import { ROLE } from 'constant/role';
import { ClassList, ClassInfo, ImportStudentList } from 'Pages/Class';
import { CreateStudent, StudentInfo, StudentList } from 'Pages/Student';
import { CreateParent, ParentInfo, ParentList } from 'Pages/Parent';
import { ClassYearInfo, ClassYearList, CreateClassYear } from 'Pages/Class_year';
import { HomeroomClassDetail, HomeroomClassList } from 'Pages/Homeroom-classes';
import { SubjectClassList } from 'Pages/Teaching-classes/List';
import { SubjectClassDetail } from 'Pages/Teaching-classes';
import RevenueSourceList from 'Pages/Revenue/List';
import { StudentFullInfo } from 'Pages/Revenue';
import { ClassYearIncome } from 'Pages/Class_income/List';
import { IncomeInfo } from 'Pages/Class_income/Information';
import MenuConfig from '../Pages/MenuConfig';
import RevenueBlockList from 'Pages/RevenueBlock';
import QuickRegisterPage from 'Pages/QuickRegister';
import ClassIncomeBoard from 'Pages/ClassIncomeBoard';
import ClassAttendanceBoard from 'Pages/ClassAttendanceBoard';
import ClassActualSettleBoard from 'Pages/ClassActualSettleBoard';
import ClassCarryForwardBoard from 'Pages/ClassCarryForwardBoard';
import ClassPaymentStatistics from 'Pages/ClassPaymentStatistics';
import WorkMonthConfig from 'Pages/WorkMonth';
import ReportsHubPage from 'Pages/Reports';


export const ADMIN_ROUTER = [
  {
    key: 'menu-config',
    path: '/menu-config',
    role: ROLE.ADMIN,
    element: <MenuConfig />,
  },
  {
    key: 'home',
    path: '/',
    element: <Home />,
  },
  {
    key: 'profile',
    path: '/profile',
    navKey: 'pf',
    element: <Profile />,
  },
  {
    key: 'add-account',
    path: '/add-account',
    role: ROLE.ADMIN,
    navKey: 'ac',
    element: <CreateAccount />,
  },
  {
    key: 'student-list',
    path: '/student-list',
    role: [ROLE.ADMIN, ROLE.ACCOUNTANT], // <-- array thay vì string
    navKey: 'stl',
    element: <StudentList />,
  },
  {
    key: 'account-list',
    path: '/account-list',
    role: ROLE.ADMIN,
    navKey: 'cl',
    element: <AccountList />,
  },
  {
    key: 'account-info',
    path: '/account-list/account-info/:accountId',
    role: ROLE.ADMIN,
    navKey: 'cl',
    subNavKey: 'ci',
    element: <AccountInfo />,
  },
  // {
  //   key: 'add-class',
  //   path: '/add-class',
  //   role: ROLE.ADMIN,
  //   navKey: 'acl',
  //   element: <CreateClass />,
  // },
  {
    key: 'add-parent',
    path: '/add-parent',
    role: ROLE.ADMIN,
    navKey: 'ap',
    element: <CreateParent />,
  },
  {
    key: 'add-class-year',
    path: '/add-class-year',
    role: ROLE.ADMIN,
    navKey: 'acy',
    element: <CreateClassYear />,
  },
  {
    key: 'class-year-list',
    path: '/class-year-list',
    role: [ROLE.ADMIN, ROLE.ACCOUNTANT], // <-- array thay vì string
    navKey: 'cyl',
    element: <ClassYearList />,
  },

  {
    key: 'parent-list',
    path: '/parent-list',
    role: [ROLE.ADMIN, ROLE.ACCOUNTANT],
    navKey: 'pl',
    element: <ParentList />,
  },
  {
    key: 'class-list',
    path: '/class-list',
    role: [ROLE.ADMIN, ROLE.ACCOUNTANT], // <-- array thay vì string
    navKey: 'cll',
    element: <ClassList />,
  },
  {
    key: 'revenue-sources',
    path: '/revenue-sources',
    role: ROLE.ACCOUNTANT,
    navKey: 'rs',
    element: <RevenueSourceList />,
  },
  {
    key: 'revenue-blocks',
    path: '/revenue-blocks',
    role: [ROLE.ADMIN, ROLE.ACCOUNTANT],
    navKey: 'rb',
    element: <RevenueBlockList />,
  },
  {
    key: 'quick-register',
    path: '/quick-register',
    role: [ROLE.ADMIN, ROLE.ACCOUNTANT],
    navKey: 'qr',
    element: <QuickRegisterPage />,
  },
  {
    key: 'work-month',
    path: '/work-month',
    role: [ROLE.ADMIN, ROLE.ACCOUNTANT],
    navKey: 'wm',
    element: <WorkMonthConfig />,
  },
  {
    key: 'revenue-source',
    path: '/revenue-source/:studentId/class/:classYearId',
    role: ROLE.ACCOUNTANT,
    navKey: 'clyi',
    subNavKey: 'ii',
    subSubNavKey: 'sfi',
    element: <StudentFullInfo />,
  },
  {
    key: 'parent-info',
    path: '/parent-info/:parentId',
    role: [ROLE.ADMIN, ROLE.ACCOUNTANT],
    element: <ParentInfo />,
  },
  {
    key: 'class-year-info',
    path: '/class-year-info/:classYearId',
    navkey: 'cyi',
    role: [ROLE.ADMIN, ROLE.ACCOUNTANT],
    element: <ClassYearInfo />,

  },
  {
    key: 'detail-class-year-income',
    path: '/detail-class-year-income/:classYearId',
    navKey: 'clyi',
    subNavKey: 'ii',
    role: [ROLE.ADMIN, ROLE.ACCOUNTANT],
    element: <IncomeInfo />,

  },
  {
    key: 'class-year-income',
    path: '/class-year-income',
    navKey: 'clyi',
    role: [ROLE.ADMIN, ROLE.ACCOUNTANT],
    element: <ClassIncomeBoard />,
  },
  {
    key: 'class-month-attendance',
    path: '/class-month-attendance',
    navKey: 'cma',
    role: ROLE.ACCOUNTANT,
    element: <ClassAttendanceBoard />,
  },
  {
    key: 'class-actual-settle',
    path: '/class-actual-settle',
    navKey: 'cas',
    role: ROLE.ACCOUNTANT,
    element: <ClassActualSettleBoard />,
  },
  {
    key: 'class-settle-carry-forward',
    path: '/class-settle-carry-forward',
    navKey: 'cscf',
    role: ROLE.ACCOUNTANT,
    element: <ClassCarryForwardBoard />,
  },
  {
    key: 'class-payment-statistics',
    path: '/class-payment-statistics',
    navKey: 'cps',
    role: ROLE.ACCOUNTANT,
    element: <ClassPaymentStatistics />,
  },
  {
    key: 'reports',
    path: '/reports',
    navKey: 'rpt',
    role: [ROLE.ADMIN, ROLE.ACCOUNTANT],
    element: <ReportsHubPage />,
  },
  {
    key: 'class-year-income-legacy',
    path: '/class-year-income-legacy',
    navKey: 'clyi',
    role: [ROLE.ADMIN, ROLE.ACCOUNTANT],
    element: <ClassYearIncome />,
  },
  {
    key: 'student-info',
    path: '/student-list/student-info/:studentId',
    role: [ROLE.ADMIN, ROLE.ACCOUNTANT], // <-- array thay vì string
    navKey: 'stl',
    subNavKey: 'sti',
    element: <StudentInfo />, // component mới
  },
  {
    key: 'class-info',
    path: '/class-list/class-info/:classId',
    role: [ROLE.ADMIN, ROLE.ACCOUNTANT], // <-- array thay vì string
    navKey: 'cll',
    subNavKey: 'cli',
    element: <ClassInfo />,
  },
  {
    key: 'import-student-list',
    path: '/import-student-list',
    role: [ROLE.ADMIN, ROLE.ACCOUNTANT], // <-- array thay vì string
    navKey: 'ist',
    element: <ImportStudentList />,
  },
  {
    key: 'add-student',
    path: '/add-student',
    role: [ROLE.ADMIN, ROLE.ACCOUNTANT], // <-- array thay vì string
    navKey: 'stl',
    subNavKey: 'ast',
    element: <CreateStudent />,
  },
  {
    key: 'add-bill',
    path: '/add-bill',
    role: ROLE.ACCOUNTANT,
    navKey: 'ab',
    element: <CreateBill />,
  },
  {
    key: 'bill-list',
    path: '/bill-list',
    role: ROLE.ACCOUNTANT,
    navKey: 'bl',
    element: <BillList />,
  },
  {
    key: 'qr-payment-slip',
    path: '/qr-payment-slip',
    role: ROLE.ACCOUNTANT,
    navKey: 'qps',
    element: <QrPaymentSlipPage />,
  },
  {
    key: 'pending-approval-bill-list',
    path: '/pending-approval-bill-list',
    role: ROLE.ACCOUNTANT,
    navKey: 'pbl',
    element: <PendingApprovalBillList />,
  },
  {
    key: 'bill-info',
    path: '/bill-list/bill-info/:studentInvoiceId',
    role: ROLE.ACCOUNTANT,
    navKey: 'bl',
    subNavKey: 'bi',
    element: <BillInfo />,
  },
  {
    key: 'invoice-history',
    path: '/invoice-history',
    role: ROLE.ACCOUNTANT,
    navKey: 'ih',
    element: <InvoiceHistory />,
  },
  {
    key: 'invoice-config',
    path: '/invoice-config',
    role: ROLE.ACCOUNTANT,
    navKey: 'ic',
    element: <InvoiceConfig />,
  },
  {
    key: 'add-student',
    path: '/add-student',
    role: ROLE.TEACHER,
    navKey: 'ast',
    element: <CreateStudent />,
  },
  {
    key: 'homeroom-classes',
    path: '/homeroom-classes',
    role: ROLE.TEACHER,
    navKey: 'hc',
    element: <HomeroomClassList />,
  }, {
    key: 'homeroom-class-detail',
    path: '/homeroom-class-detail/:classYearId',
    role: ROLE.TEACHER,
    navKey: 'hcd',
    element: <HomeroomClassDetail />,
  },
  {
    key: 'subject-class-list',
    path: '/subject-class-list',
    role: ROLE.TEACHER,
    navKey: 'scl',
    element: <SubjectClassList />,
  }, {
    key: 'subject-class-detail',
    path: '/subject-class-detail/:classYearId',
    role: ROLE.TEACHER,
    navKey: 'scd',
    element: <SubjectClassDetail />,
  },
  {
    key: 'student-list',
    path: '/student-list',
    role: ROLE.TEACHER,
    navKey: 'stl',
    element: <StudentList />,
  },
  // {
  //   key: 'student-info',
  //   path: '/student-list//:studentId',
  //   role: ROLE.TEACHER,
  //   navKey: 'stl',
  //   subNavKey: 'sti',
  //   element: <StudentInfo />,
  // },
];

export const PATH_INFO = {
  '/': { title: 'Trang chủ' },
  '/menu-config': { title: 'Cấu hình Menu' },
  '/add-account': { title: 'Thêm tài khoản' },
  '/account-list': {
    title: 'Danh sách tài khoản',
    tabList: ['Admin Trường', 'Hiệu trưởng', 'Giáo viên', 'Kế toán'],
  },
  '/class-year-info': {
    title: 'Chi tiết lớp học theo năm',
  },
  '/parent-info': {
    title: 'Chi tiết tài khoản phụ huynh',
  },

  '/revenue-sources': {
    title: 'Cấu hình nguồn thu'
  },
  '/revenue-blocks': {
    title: 'Cấu hình khối thu'
  },
  '/work-month': {
    title: 'Cấu hình tháng làm việc'
  },
  '/class-month-attendance': {
    title: 'Chấm ngày',
  },
  '/class-actual-settle': {
    title: 'Chốt thực tế',
  },
  '/class-settle-carry-forward': {
    title: 'Kết chuyển số dư',
  },
  '/class-payment-statistics': {
    title: 'Theo dõi thu nộp',
  },
  '/reports': {
    title: 'Báo cáo - Thống kê',
  },
  '/revenue-source': {
    title: 'Chi tiết nguồn thu'
  },
  '/account-list/account-info': {
    title: 'Chi tiết tài khoản',
    // tabList: ['Thông tin chung', 'Danh sách tổ chức'],
  },
  '/add-bill': {
    title: 'Thêm biên lai',
    tabList: ['Thêm biên lai bán trú', 'Thêm biên lai BHYT', 'Lỗi thêm biên lai'],
  },
  '/bill-list': {
    title: 'Danh sách biên lai',
    tabList: ['Chờ thanh toán', 'Đã thanh toán / Xuất hóa đơn', 'Lịch sử hủy biên lai'],
  },
  '/pending-approval-bill-list': {
    title: 'Danh sách chờ duyệt',
  },
  '/qr-payment-slip': {
    title: 'Gộp & Xuất QR Học Phí',
  },
  '/bill-list/bill-info': {
    title: 'Chi tiết biên lai',
  },
  '/invoice-history': {
    title: 'Lịch sử hóa đơn',
  },
  '/invoice-config': {
    title: 'Cấu hình hóa đơn',
  },
  '/profile': {
    title: 'Chi tiết tài khoản',
  },
  '/add-class': {
    title: 'Thêm lớp học',
  },
  '/class-list': {
    title: 'Danh sách lớp học',
  },
  '/class-year-list': {
    title: 'Danh sách lớp học theo năm',
  },
  '/class-list/class-info': {
    title: 'Chi tiết lớp học',
  },
  '/import-student-list': {
    title: 'Nhập danh sách học sinh',
  },
  '/add-student': {
    title: 'Thêm học sinh',
  },
  '/student-list': {
    title: 'Danh sách học sinh',
    tabList: ['Học sinh đang học', 'Học sinh đã học', 'Lỗi thêm học sinh'],
  },
  '/add-parent': {
    title: 'Thêm phụ huynh',
  },
  '/parent-list': {
    title: 'Danh sách phụ huynh',
  },
  '/student-list/student-info': {
    title: 'Thông tin chi tiết học sinh',
  },
  '/homeroom-classes': {
    title: 'Danh sách lớp chủ nhiệm',
  },
  '/homeroom-class-detail': {
    title: 'Chi tiết lớp chủ nhiệm',
  },
  '/subject-class-list': {
    title: 'Danh sách lớp dạy',
  },
  '/subject-class-detail': {
    title: 'Chi tiết lớp dạy',
  },
  '/detail-class-year-income': {
    title: 'Chi tiết nguồn thu theo lớp',
    tabList: ['Danh sách học sinh', 'Giáo viên chủ nhiệm', 'Giáo viên bộ môn'],
  },
  '/class-year-income': {
    title: 'Danh sách nguồn thu theo lớp',
  },
  '/class-year-income-legacy': {
    title: 'Danh sách nguồn thu theo lớp (Cũ)',
  },
  '/quick-register': {
    title: 'Đăng ký nhanh nguồn thu',
  },
};
